/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import "./index.css";

import { toast } from "react-toastify";
import {
  addItemizedStatementDescription,
  downloadAllItemisizedReport,
  getAllOwnerItemisizedReport,
  ownerAccountsViewAll,
  resetItemisedData,
  setOwnerAllAccItemisedLoading,
  updateItemizedStatementData,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "../../../_utils/PaginationComponent";
import { formatAccountNumber } from "../../../_utils/FormatAccountNumber";

import IfscCodeMapper from "../../../_utils/IfscLogoMapper";
import OwnerAccountPopUp from "../OwnerAccountPopUp";
import FormatAmount from "../../../_utils/FormatAmount/FormatAmount";
import Loader from "../../../Loader/Index";
import PrimaryButton from "../../../_utils/CommonButtons/PrimaryButton";
import PrimaryWithIconButton from "../../../_utils/CommonButtons/PrimaryWithIconButton";

import SVGComponent from "../../../_utils/SVGComponent";

import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import SmallPopupWithInput from "../../../_utils/CommonSmallPopupWithInput";
import { linkIdentifier } from "../../../../utils/linkIdentifier";
import CommonToast from "../../../_utils/CommonToast";
import UniversalRefreshToast from "../../../_utils/UniversalRefreshToast";
import ICONS from "../../../../assets/Icons";
import StatementTopNavComponent from "../../../_utils/CommonTopNav/StatementTopNavComponent";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams";
import {
  addMatchItemisedStatement,
  getAssociatedItemisedStatements,
  removeUnmatchItemisedStatement,
  resetDateRange,
  resetItemisedAllAccStatementData,
  setEndDate,
  setGetItemisedAllAccStatementLoading,
  setStartDate,
} from "../../../../redux/features/accounts/remitterAccount/remitterAccount";
import RemitAccountViewAllPopup from "../../RemitAccount/RemitAccountViewAllPopup";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopup from "../../../_utils/CommonSmallPopup";
import RemitterAccountViewAll from "../../../../containers/Accounts/RemitterAccount/RemitterAccountViewAll";
import SecondaryAnimatedButton from "../../../_utils/CommonButtons/SecondaryAnimated";
import SwitcherTabs from "../../../_utils/CommonButtons/SwitcherTabs";
import CountdownTimer from "../../../../utils/countDownCountdownTimer";
import CardActionableButton from "../../../_utils/CommonViewAllCard/CardSubComponent/CardActionableButton";
import useRestrictedAction from "../../../../hooks/useRestrictedAction";

const OwnerAccountConsolidatedLiveStatementComp = (props) => {
  const isFirstRender = useRef(true);
  const pollingTimeoutRef = useRef(null);
  const amtDivRef = useRef(null);
  const location = useLocation();
  const id = location?.state?.data;
  const type = location?.state?.type;
  const startDateDetails = location?.state?.startDate;
  const endDateDetails = location?.state?.endDate;
  const ownerIddetails = location?.state?.ownerId;
  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();
  const { getAssociatedItemisedData, getAssociatedItemisedLoading } =
    useSelector((state) => state.remitterAccount);
  const {
    ownerAllAccItemisedData,
    ownerAllAccItemisedLoading,
    ownerItemizedAddDescriptionLoading,
  } = useSelector((state) => state.ownerAllVerification);
  const services = useSelector((state) => state.refreshToken.services);
  const dropdownOptionsList = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams } = useCustomSearchParams({
    pageno: GlobalConfiguration.lengthCheckOne,
    pagesize: dropdownOptionsList[0],
  });

  const hasMatchPermission = services?.some(
    (service) => service === "AMapping" || service === "Admin",
  );
  const hasUnMatchPermission = services?.some(
    (service) => service === "RMapping" || service === "Admin",
  );

  const hasViewPermission = services?.some(
    (service) => service === "REVAccount" || service === "Admin",
  );

  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );

    return timestamp;
  };

  const defaultStartDate = useMemo(() => {
    return convertDate(new Date(new Date().setDate(1)));
  }, []);

  const defaultEndDate = useMemo(() => {
    return convertDate(new Date());
  }, []);

  const navigate = useNavigate();
  const scrollTopRef = useRef(null);
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const [showOwnerPopup, setShowOwnerPopup] = useState(false);

  const [loading, setLoading] = useState(false);
  const [remType, setRemType] = useState("");
  const [matchRemiId, setMatchRemiId] = useState([]);
  const [matchId, setMatchId] = useState(location?.state?.data || "");
  const [totalRemiAccount, setTotalRemiAccount] = useState([]);
  const [matchLoader, setMatchLoader] = useState(false);
  const [unmatchLoader, setUnmatchLoader] = useState(false);
  const [selectedCardIds, setSelectedCardIds] = useState([]);
  const [creditAmount, setCreditAmount] = useState("");
  const [remitterName, setRemitterName] = useState(
    location?.state?.remName || "",
  );
  const [selectedStatementRemitters, setSelectedStatementRemitters] = useState(
    {},
  );
  const [showRemiAccounts, setShowRemiAccounts] = useState(false);
  const [selectedLiveStatement, setSelectedLiveStatement] = useState(
    location?.state?.statementid || [],
  );
  const [selectStatementType, setSelectStatementType] = useState(
    location?.state?.flow || "",
  );
  const [matchFlowType, setMatchFlowType] = useState(
    location?.state?.flow || "",
  );
  const [remiAcoountId, setRemiAcoountId] = useState(id || []);
  const [openMatchPopup, setOpenMatchPopup] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [openDateFilter, setopenDateFilter] = useState(false);
  const [showAmtFilterDiv, setShowAmtFilterDiv] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isAmtFilterApplied, setIsAmtFilterApplied] = useState(false);
  const [amountRangeFilter, setAmountRangeFilter] = useState({
    min: searchParam.get("min_amount") || "",
    max: searchParam.get("max_amount") || "",
  });
  const [resetTrigger, setResetTrigger] = useState(0);
  const [isDateConfirm, setIsDateConfirm] = useState(false);
  const [flowType, setFlowType] = useState(location?.state?.flow || "");
  const [isFocused, setIsFocused] = useState(false);
  const [statementType, setStatementType] = useState("Credit");

  const [showDescriptionPopup, setShowDescriptionPopup] = useState(false);
  const [description, setDescription] = useState("");
  const [currentDescription, setCurrentDescription] = useState({});
  const [isEditDescription, setIsEditDescription] = useState(false);
  const [matchButton, setMatchButton] = useState(
    (selectStatementType === "remitter_details_match_statement" ||
      selectStatementType === "remitter_edit_match_statement" ||
      flowType === "new_match_txn") &&
      ownerAllAccItemisedData?.ecollection_callbacks >
        GlobalConfiguration.lengthCheckZero
      ? true
      : false,
  );
  const [inputData, setInputData] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [active, setActive] = useState("");
  const [selectStatementRow, setSelectStatementRow] = useState([]);
  const [unmatchStatement, setUnMatchStatement] = useState("");
  const [matchStatement, setMatchStatement] = useState("");
  const scrollRef = useRef(null);
  const [filterOpen, setFilterOpen] = useState(false);
  const [showAdditionalDetails, setShowAdditionalDetails] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const calenderRef = useRef(null);
  const calenderButtonRef = useRef(null);
  const additionalDetailsRef = useRef(null);
  const [unmatchRemiId, setUnmatchRemiId] = useState([]);
  const [alertPopup, setAlertPopup] = useState(false);
  const [pendingNavTarget, setPendingNavTarget] = useState(null);
  const additionalDetailsBtnRef = useRef(null);
  const filterButtonRef = useRef(null);
  const selectAccountRef = useRef(null);
  const [pageSize, setPageSize] = useState(dropdownOptions[0]);
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
  const dispatch = useDispatch();
  const filterRef = useRef(null);
  const filterapplyButtonRef = useRef(null);
  const addtionalapplyButtonRef = useRef(null);
  const calenderapplyButtonRef = useRef(null);
  const [selectedtBankState, setSelectedtBankState] = useState("");
  const [selectedtBank, setSelectedtBank] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [amountLimitState, setAmountLimitState] = useState({
    min: "",
    max: "",
  });
  const [amountLimit, setAmountLimit] = useState({
    min: "",
    max: "",
  });

  const [accountnumberstate, setaccountnumberstate] = useState(
    ownerIddetails
      ? [ownerIddetails]
      : props?.flow === "rejectStatementdetails"
        ? []
        : props?.popType === "ownerStatement" ||
            props?.popType === "remitterBankStatement"
          ? props?.ownerDetailId
            ? [props?.ownerDetailId]
            : []
          : [],
  );
  const [accountNumber, setAccountNumber] = useState(
    ownerIddetails
      ? location?.state?.type === "consolidatedFullView" ? [ownerIddetails] :ownerIddetails 
      : props?.popType == "ownerStatement" || props?.popType
        ? [props?.ownerDetailId]
        : [],
  );
  const [accountDefaultNumber, setDefaultAccountNumber] = useState(
    ownerIddetails
      ? [ownerIddetails]
      : props?.popType == "ownerStatement" || props?.popType
        ? [props?.ownerDetailId]
        : [],
  );

  const [selectedType, setSelectedType] = useState("XLSX");

  const [startDateState, setStartDateState] = useState(
    startDateDetails ||
      (props?.flow === "rejectStatementdetails" ? "" : defaultStartDate),
  );
  // const [startDate, setStartDate] = useState(new Date(new Date().setDate(1)));
  const [endDateState, setEndDateState] = useState(
    endDateDetails ||
      (props?.flow === "rejectStatementdetails" ? "" : defaultEndDate),
  );
  // const [endDate, setEndDate] = useState(new Date());

  const matchCondition =
    matchFlowType === "new_match_txn" ||
    matchFlowType === "remitter_details_match_statement" ||
    matchFlowType === "remitter_edit_match_statement";

  const columnMapper = {
    owner_bank_account_number: "owner_bank_account_number",
    IFSC_Code: "ifsc_code",
    Bank: "bank_name",
    Name: "name",
    Party_name: "party_name",
    Party_IFSC: "party_ifsc",
    Party_account_number: "party_account_number",
    Transaction_date: "transaction_date",
    Value_date: "value_date",
    Narration: "narration",
    Amount: "amount",
    Bank_reference: "bank_reference",
    Type: "credit_debit",
    Description: "description",
  };

  const callbacks =
    type === "remitter_details" ||
    props?.flow === "remitter_details" ||
    props?.flow === "rejectStatementdetails"
      ? getAssociatedItemisedData?.ecollection_callbacks
      : ownerAllAccItemisedData?.ecollection_callbacks;

  const visibleRowIds =
    callbacks?.map(
      (item, index) =>
        item?.ecollection_callback_id || item?.id || `${currentPage}-${index}`,
    ) || [];

  const currentPageSelectableIds = visibleRowIds.filter(
    (id) => !selectedLiveStatement?.includes(id),
  );

  const currentPageSelectedIds = currentPageSelectableIds.filter((id) =>
    selectStatementRow.includes(id),
  );

  const currentPageSelectedCount = currentPageSelectedIds.length;

  const totalUserSelectedCount = selectStatementRow.filter(
    (id) => !selectedLiveStatement?.includes(id),
  ).length;

  const remainingSelection = Math.max(
    Number(pageSize) - totalUserSelectedCount,
    0,
  );

  const hasSelectionOutsideCurrentPage =
    currentPageSelectedCount === GlobalConfiguration.lengthCheckZero &&
    selectStatementRow.some(
      (id) =>
        !selectedLiveStatement?.includes(id) &&
        !currentPageSelectableIds.includes(id),
    );

  const shouldClearPreviousSelection =
    hasSelectionOutsideCurrentPage &&
    remainingSelection === GlobalConfiguration.lengthCheckZero;

  const totalSelectedCount = totalUserSelectedCount;

  const totalVisibleSelectableCount = currentPageSelectableIds.length;

  const isAllVisibleSelected =
    totalVisibleSelectableCount > 0 &&
    currentPageSelectedCount === totalVisibleSelectableCount;
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= 0) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };
  const defaultAdditionalDetailCol = [
    { colName: "Bank", colWidth: "column-width-sm", flex: 0 },
    {
      colName: "Transaction date",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Value date",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Party name",
      colWidth: "column-width-lg",
      flex: 1,
    },
    {
      colName: `Amount`,
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Narration",
      colWidth: "column-width-lg",
      flex: 1,
    },
    {
      colName: "Bank reference",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Party account number",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Party IFSC",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Description",
      colWidth: "column-width-lg",
      flex: 1,
    },
    ...(props?.flow !== "rejectStatementdetails"
      ? [
          {
            colName: "Remitter account",
            colWidth: "column-width-lg",
            flex: 1,
          },
        ]
      : []),
  ];
  const [additionalDetailCol, setAdditionalDetailsCol] = useState(
    defaultAdditionalDetailCol,
  );

  const [additionalDetailColState, setAdditionalDetailsColState] = useState(
    defaultAdditionalDetailCol,
  );

  const condition =
    (startDateState !== defaultStartDate && endDateState !== defaultEndDate) ||
    selectedtBankState.length > GlobalConfiguration.lengthCheckZero ||
    (matchStatement !== "" && unmatchStatement !== "") ||
    matchStatement !== "" ||
    unmatchStatement !== "" ||
    creditAmount !== "" ||
    (amountRangeFilter.min.length > GlobalConfiguration.lengthCheckZero &&
      amountRangeFilter.max.length > GlobalConfiguration.lengthCheckZero);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response = await dispatch(ownerAccountsViewAll({}));
      } catch (error) {}
    };

    fetchData();

    return () => {
      dispatch(resetItemisedData());
    };
  }, []);

  const timerRef = useRef(null);

  const isToday = (date) => {
    const d = new Date(date * 1000);
    const today = new Date();
    return (
      d.getFullYear() === today.getFullYear() &&
      d.getMonth() === today.getMonth() &&
      d.getDate() === today.getDate()
    );
  };

  const clearPolling = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  };

  const startPolling = () => {
    clearPolling();

    if (!isToday(endDateState) || matchButton) return;

    timerRef.current = setTimeout(
      async () => {
        await fetchData();
      },
      5 * 60 * 1000,
    );
  };

  const fetchData = async () => {
    setResetTrigger((prev) => prev + 1);
    if (
      type === "remitter_details" ||
      props?.flow === "remitter_details" ||
      props?.flow === "rejectStatementdetails"
    ) {
      dispatch(
        getAssociatedItemisedStatements({
          page_no: currentPage,
          page_size: pageSize,
          remitter_account_id: props?.remitter_account_id,
          ecollection_callback_id: props?.statement_entry_id
            ? props?.statement_entry_id
            : [],
          min_amount: isAmtFilterApplied ? amountRangeFilter.min : "",
          max_amount: isAmtFilterApplied ? amountRangeFilter.max : "",
          start_date: startDateState,
          end_date: endDateState,
        }),
      );
    } else {
      await dispatch(
        getAllOwnerItemisizedReport({
          id: accountNumber?.map((itm) => (itm?.id ? itm?.id : itm)),
          start_date: startDateState,
          end_date: endDateState,
          page_no: currentPage,
          sort_by:
            matchStatement === "Matched"
              ? "mapped"
              : unmatchStatement === "Unmatched"
                ? "unmapped"
                : "",
          credit_debit: statementType?.toLowerCase(),
          start_amount: isAmtFilterApplied ? amountRangeFilter.min : "",
          end_amount: isAmtFilterApplied ? amountRangeFilter.max : "",
          credit_amount: creditAmount || "",
          page_size: pageSize,
          bank_name: selectedtBank.length ? selectedtBank : undefined,
        }),
      ).unwrap();
    }
    startPolling();
  };

  useEffect(() => {
    if (!accountNumber.length) {
      if (
        type === "remitter_details" ||
        props?.flow === "remitter_details" ||
        props?.flow === "rejectStatementdetails"
      ) {
        dispatch(setGetItemisedAllAccStatementLoading(false));
      } else {
        dispatch(setOwnerAllAccItemisedLoading(false));
      }
      clearPolling();
      return;
    }

    fetchData();

    return () => {
      dispatch(resetItemisedAllAccStatementData());

      clearPolling();
    };
  }, [
    accountNumber,
    currentPage,
    pageSize,
    selectedtBank,
    amountRangeFilter,
    creditAmount,
    startDateState,
    endDateState,
    type,
    matchStatement,
    statementType,
    unmatchStatement,
  ]);

  const handleApplyEnable = () => {
    if (
      accountDefaultNumber.length &&
      accountnumberstate.length &&
      !accountNumber.length
    ) {
      return true;
    }
    if (
      accountDefaultNumber.length === accountnumberstate.length &&
      accountDefaultNumber.every((ac) => {
        return accountnumberstate.includes(ac);
      }) &&
      accountDefaultNumber.length === accountNumber.length &&
      accountDefaultNumber.every((ac) => {
        return accountNumber.includes(ac);
      }) &&
      !selectedtBank.length &&
      !amountLimit.min.length &&
      !amountLimit.max.length &&
      !selectedtBankState.length &&
      !isAmtFilterApplied
    ) {
      return false;
    }
    return true;
  };

  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  const handleAddDetailaApplyEnable = () => {
    return (
      JSON.stringify(defaultAdditionalDetailCol.map((x) => x.colName)) !=
        JSON.stringify(additionalDetailColState.map((x) => x.colName)) ||
      JSON.stringify(defaultAdditionalDetailCol.map((x) => x.colName)) !=
        JSON.stringify(additionalDetailCol.map((x) => x.colName))
    );
  };

  const handleMatchStatement = async (matchid) => {
    setMatchLoader(true);
    UniversalRefreshToast(
      flowType === "new_match_txn" ||
        flowType === "remitter_details_match_statement" ||
        selectStatementType === "remitter_edit_match_statement"
        ? "Matching transactions to the selected accounts."
        : "Matching remitter.",
    );
    try {
      const data = await dispatch(
        addMatchItemisedStatement({
          remitter_accounts_ids: Array.isArray(matchid) ? matchid : [matchid],
          mapping_ids: Array.isArray(selectStatementRow)
            ? selectStatementRow
            : [selectStatementRow],
        }),
      );

      if (data?.payload?.status === true) {
        toast.dismiss();
        CommonToast({
          text:
            flowType === "new_match_txn" ||
            flowType === "remitter_details_match_statement" ||
            selectStatementType === "remitter_edit_match_statement"
              ? `${
                  selectStatementRow?.length ===
                  GlobalConfiguration.lengthCheckOne
                    ? "Transaction"
                    : "Transactions"
                } matched to the selected ${matchCondition ? "account" : "accounts"} successfully.`
              : "Remitter matched successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
        if (remiAcoountId?.length > GlobalConfiguration.lengthCheckZero) {
          navigate(
            `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${remiAcoountId}`,
            {
              state: {
                flow: "live_match_transaction",
              },
            },
          );
        } else {
          setOpenMatchPopup(false);
          setShowRemiAccounts(false);
          setSelectedCardIds([]);
          fetchData();
          setMatchButton(false);
          setSelectStatementRow([]);
        }
      } else {
        CommonToast({
          text:
            data?.payload?.message ||
            data?.payload?.errors?.base?.[0] ||
            "Failed to unmatch transactions.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    } catch (error) {
      CommonToast({
        text: "Something went wrong.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
    setOpenMatchPopup(false);
    setMatchLoader(false);
    setRemType("");
  };

  const handleUnMatchStatement = async (matchid) => {
    setUnmatchLoader(true);
    UniversalRefreshToast("Unmatching remitter.");

    try {
      let data = await dispatch(
        removeUnmatchItemisedStatement({
          remitter_accounts_ids: matchid,
          mapping_ids: Array.isArray(selectStatementRow)
            ? selectStatementRow
            : [selectStatementRow],
        }),
      );

      if (data?.payload?.status === true) {
        toast.dismiss();
        CommonToast({
          text: "Remitter unmatched successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });

        setShowRemiAccounts(false);
        setSelectStatementRow([]);
        setUnmatchRemiId([]);
        fetchData();
        setSelectedCardIds([]);
      } else {
        CommonToast({
          text:
            data?.payload?.message ||
            data?.payload?.errors?.base?.[0] ||
            "Failed to unmatch transactions.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setSelectStatementRow([]);
        setUnmatchRemiId([]);
        setUnmatchLoader(false);
      }
    } catch (error) {
      CommonToast({
        text: "Something went wrong.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
    setOpenMatchPopup(false);
    setUnmatchLoader(false);
    setRemType("");
  };

  const handleAlertCancel = () => {
    setAlertPopup(false);
    setPendingNavTarget(null);
  };

  const handleLeaveConfirm = () => {
    setAlertPopup(false);
    setShowRemiAccounts(false);
    if (pendingNavTarget) {
      navigate(pendingNavTarget);
    }
    setPendingNavTarget(null);
  };

  const downloadStatement = async () => {
    UniversalRefreshToast("Downloading statement.");
    setIsDisabled(true);
    try {
      const response = await dispatch(
        downloadAllItemisizedReport({
          id: accountNumber,
          start_date: startDateState,
          end_date: endDateState,
          credit_debit: statementType?.toLowerCase(),
          start_amount: isAmtFilterApplied ? amountRangeFilter.min : "",
          end_amount: isAmtFilterApplied ? amountRangeFilter.max : "",
          page_size: pageSize,
          formatType: selectedType.toLowerCase(),
          bank_name: selectedtBank.length ? selectedtBank : undefined,
          filter_columns: additionalDetailColState?.map(
            (itm) => columnMapper[itm.colName.replaceAll(" ", "_")],
          ),
        }),
      );
      toast.dismiss();
      CommonToast({
        text: "Statement downloaded successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      setIsDisabled(false);
    } catch (error) {
      toast.dismiss();
      CommonToast({
        text: "Failed to download statement.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setIsDisabled(false);
      console.error(error);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
    }
    if (filterOpen) {
      if (event.key === "Enter" && !showAmtFilterDiv && handleApplyEnable()) {
        filterapplyButtonRef.current.click();
      }
    }
    if (showCalendar) {
      if (
        event.key === "Enter" ||
        (isDateConfirm && startDateState && endDateState)
      ) {
        calenderapplyButtonRef.current.click();
      }
    }
    if (showAdditionalDetails) {
      if (event.key === "Enter" && handleAddDetailaApplyEnable()) {
        addtionalapplyButtonRef.current.click();
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [
    filterOpen,
    showCalendar,
    showAdditionalDetails,
    showAmtFilterDiv,
    handleAddDetailaApplyEnable,
    handleApplyEnable,
  ]);

 
    const actionRestricted = () => {
      showRestrictedAction({
        path: `/owner_account_dashboard/consolidated_live_statement/`,
           state: {
                        startDate: startDateState,
                        endDate: endDateState,
                        ownerId: accountNumber,
                      },
      });
    };

  const handleDateChange = (date) => {
    const [start, end] = date;
    if (start !== null && end !== null) {
      const startTs = convertDate(start);
      const endTs = convertDate(end);
      setStartDateState(startTs);
      setEndDateState(endTs);
      if (props?.flow === "remitterBankStatement") {
        // Setting Dates in redux... will help in setting dates when redirecting from popup to full view.
        dispatch(setStartDate(startTs));
        dispatch(setEndDate(endTs));
      }
      handleSearchParams("date", `${startTs},${endTs}`);
    } else {
      setStartDateState(defaultStartDate);
      setEndDateState(defaultEndDate);

      handleSearchParams("date", "");
    }
  };

  useEffect(() => {
    return () => {
      if (props?.flow !== "ownerDetail") {
        dispatch(resetDateRange());
      }
    };
  }, []);

  // useEffect(async () => {
  //   if (location?.state?.flow === "remitter_edit_match_statement") {
  //     const response = await dispatch(
  //       getAssociatedItemisedStatements({
  //         remitter_account_id: id,
  //       }),
  //     );

  //     console.log("response", response);
  //   }
  // }, [location?.state?.flow, id]);

  useEffect(() => {
    const fetchItemisedStatements = async () => {
      if (
        type === "remitter_details" ||
        props?.flow === "remitter_details" ||
        props?.flow === "rejectStatementdetails"
      ) {
        const response = await dispatch(
          getAssociatedItemisedStatements({
            remitter_account_id: remiAcoountId,
            page_no: currentPage,
            page_size: pageSize,
          }),
        );

        if (getAssociatedItemisedStatements.fulfilled.match(response)) {
          const callbacks = response?.payload?.ecollection_callbacks || [];

          const statementIds = callbacks
            .map((data) => data?.ecollection_callback_id)
            .filter(Boolean);

          setSelectedLiveStatement(statementIds);
        }
      }
    };

    if (matchCondition) {
      fetchItemisedStatements();
    }
  }, [currentPage, pageSize, remiAcoountId]);
  const move = () => {
    scrollRef?.current?.scrollTo({ left: 0, behavior: "smooth" });
    setTimeout(() => {
      scrollTopRef?.current?.scrollTo({ top: 0, behavior: "smooth" });
    }, 500);
  };

  useEffect(() => {
    if (condition) {
      move();
    }
  }, [condition, matchStatement]);

  const handleSelect = (value) => {
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setSelectedValue(value);
    setPageSize(value);

    if (Number(value) < Number(pageSize)) {
      const callbacks =
        type === "remitter_details" ||
        props?.flow === "remitter_details" ||
        props?.flow === "rejectStatementdetails"
          ? getAssociatedItemisedData?.ecollection_callbacks
          : ownerAllAccItemisedData?.ecollection_callbacks;

      const visibleIds =
        callbacks
          ?.slice(0, Number(value))
          ?.map(
            (item, index) =>
              item?.ecollection_callback_id || item?.id || `1-${index}`,
          ) || [];

      setSelectStatementRow((prev) =>
        prev.filter(
          (id) =>
            selectedLiveStatement?.includes(id) || visibleIds.includes(id),
        ),
      );

      setSelectedStatementRemitters((prev) => {
        const updated = {};

        Object.keys(prev || {}).forEach((key) => {
          if (
            selectedLiveStatement?.includes(key) ||
            visibleIds.includes(key)
          ) {
            updated[key] = prev[key];
          }
        });

        const additionalIds = Array.isArray(remiAcoountId)
          ? remiAcoountId
          : remiAcoountId
            ? [remiAcoountId]
            : [];

        const uniqueIds = [
          ...new Set([...Object.values(updated).flat(), ...additionalIds]),
        ];

        setMatchRemiId(uniqueIds);

        return updated;
      });
    }
  };

  const handlePagination = (page) => {
    if (scrollRef?.current) {
      scrollRef.current.scrollLeft = GlobalConfiguration.lengthCheckZero;
    }
    setCurrentPage(page);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        (additionalDetailsRef.current &&
          additionalDetailsRef.current.contains(e.target)) ||
        (additionalDetailsBtnRef.current &&
          additionalDetailsBtnRef.current.contains(e.target))
      ) {
      } else {
        setShowAdditionalDetails(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [additionalDetailsRef]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        (filterRef.current && filterRef.current.contains(e.target)) ||
        (filterButtonRef.current &&
          filterButtonRef.current.contains(e.target)) ||
        (selectAccountRef.current &&
          selectAccountRef.current.contains(e.target))
      ) {
      } else {
        setFilterOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [filterRef]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        (calenderRef.current && calenderRef.current.contains(e.target)) ||
        (calenderButtonRef.current &&
          calenderButtonRef.current.contains(e.target))
      ) {
      } else {
        setShowCalendar(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [calenderRef]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (amtDivRef.current && amtDivRef.current.contains(e.target)) {
      } else {
        setShowAmtFilterDiv(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [amtDivRef]);

  useEffect(() => {
    if (
      (selectStatementType === "remitter_details_match_statement" ||
        selectStatementType === "remitter_edit_match_statement" ||
        flowType === "new_match_txn") &&
      ownerAllAccItemisedData?.ecollection_callbacks?.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      setMatchButton(true);
    }
  }, [
    selectStatementType,
    flowType,
    ownerAllAccItemisedData?.ecollection_callbacks?.length,
  ]);

  const handleAddDetail = (name) => {
    if (!additionalDetailColState.some((x) => x.colName === name)) {
      let data = {
        colName: name,
        colWidth: defaultAdditionalDetailCol.find((x) => x.colName === name)
          .colWidth,
        flex: defaultAdditionalDetailCol.find((x) => x.colName === name).flex,
      };
      let arr = [...additionalDetailColState, data].sort(
        (a, b) =>
          defaultAdditionalDetailCol.map((x) => x.colName).indexOf(a.colName) -
          defaultAdditionalDetailCol.map((x) => x.colName).indexOf(b.colName),
      );
      setAdditionalDetailsColState(arr);
    } else {
      if (additionalDetailColState?.length === 1) {
        return CommonToast({
          text: "Atleast one column is required",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      setAdditionalDetailsColState(
        additionalDetailColState
          .filter((itm) => {
            return name !== itm.colName;
          })
          .sort(
            (a, b) =>
              defaultAdditionalDetailCol
                .map((x) => x.colName)
                .indexOf(a.colName) -
              defaultAdditionalDetailCol
                .map((x) => x.colName)
                .indexOf(b.colName),
          ),
      );
    }
  };

  const handleCardNavigate = (targetPath) => {
    setPendingNavTarget(targetPath);
    setAlertPopup(true);
  };

  const formatDateandTime = (
    input,
    showtime = false,
    hour = false,
    showminutes = false,
    showmeridian = false,
    readable = false,
  ) => {
    let date;

    if (input instanceof Date) {
      date = input;
    } else if (typeof input === "number" || /^\d+$/.test(input)) {
      const ts = Number(input);
      date = new Date(ts < 1e12 ? ts * 1000 : ts);
    } else if (typeof input === "string") {
      date = new Date(input);
    } else {
      return "-";
    }

    if (isNaN(date.getTime())) return "-";

    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes();

    const ampm = hours >= 12 ? "pm" : "am";
    const displayHour = hours % 12 || 12;

    const pad = (n) => (n < 10 ? `0${n}` : n);

    // ---------- DATE PART ----------
    const datePart = readable
      ? `${day} ${date.toLocaleString("default", { month: "short" })} ${year}`
      : `${day}-${month + 1}-${year}`;

    if (!showtime) return datePart;

    // ---------- TIME PART ----------
    let timeParts = [];

    if (hour) timeParts.push(pad(displayHour));
    if (showminutes) timeParts.push(pad(minutes));

    let timePart = timeParts.join(":");

    if (showmeridian && timePart) {
      timePart += ` ${ampm}`;
    }

    return timePart ? `${datePart}, ${timePart}` : datePart;
  };

  const formatDate = (date) => {
    return `${date.getDate()} ${date.toLocaleString("default", {
      month: "short",
    })}, ${date.getFullYear()}`;
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const handleAmtFilterApply = () => {
    if (Object.values(amountLimitState).includes("")) return;
    setIsAmtFilterApplied(true);
    setTimeout(() => {
      setShowAmtFilterDiv(false);
    }, 500);
  };

  const handleKey = (event) => {
    if (showAmtFilterDiv) {
      if (event.key === "Enter" && showAmtFilterDiv && isAmtFilterApplied) {
        handleAmtFilterApply();
      }
    }
  };

  useEffect(() => {
    scrollRef.current?.scrollTo({
      left: 0,
      behavior: "smooth",
    });
  }, [condition]);

  useEffect(() => {
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("keydown", handleKey);
    };
  }, [isAmtFilterApplied, showAmtFilterDiv]);

  return (
    <>{<>{RestrictedActionPopup}</>}
      {alertPopup && (
        <div
          className="fixed z-z-index-max flex items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={(e) => e.stopPropagation()}
        >
          <SmallPopup
            headerTitle="Confirm leaving this page?"
            headerFontWeight="semibold"
            headerFontColor="emphasis"
            textSize="font-lg"
            subtext="Leaving this page will exit from current flow."
            btnOneText="Stay"
            btnOneHandleFunction={handleAlertCancel}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoHandleFunction={handleLeaveConfirm}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {showRemiAccounts && (
        <>
          <div
            className="fixed z-z-index-modal flex items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-opacity-dark-opacity"
            onClick={(e) => e.stopPropagation()}
          >
            <LargePopupRedirect
              headerTitle={
                remType === "remitterUnmatch"
                  ? "Unmatch remitter accounts"
                  : remType === "remitterMatch"
                    ? "Match remitter accounts"
                    : "Remitter accounts"
              }
              headersubtext={
                remType === "remitterUnmatch"
                  ? "Only matched active (pending & approved) accounts are enabled for selection."
                  : remType === "remitterMatch"
                    ? "Only unmatched active (pending & approved) accounts are enabled for selection."
                    : "All accounts matched to the transaction are listed below."
              }
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={() => {
                if (!matchButton) {
                  setMatchRemiId("");
                  setSelectedCardIds([]);
                  setSelectStatementRow([]);
                }
                setTotalRemiAccount("");
                setUnmatchRemiId("");
                setRemType("");
                setShowRemiAccounts(false);
              }}
              closeicon={ICONS?.CLOSE}
              closeiconhoverOption="white"
              closeiconbtnType={"button"}
              closeiconisDisabled={false}
              closeicondisabledBgColor={""}
              smallpopupsubtext="Leaving this page will exit from the current flow."
              closeiconbuttonRef={null}
              closeicontitle={"Close"}
              btnType={
                remType === "remitterUnmatch"
                  ? "Unmatch"
                  : remType === "remitterMatch"
                    ? "Match"
                    : "Confirm"
              }
              handleFunction={() => {
                if (remType === "remitterUnmatch") {
                  if (
                    selectedCardIds?.length >
                    GlobalConfiguration.lengthCheckZero
                  ) {
                    if (
                      services?.find(
                        (service) =>
                          service === "RMapping" || service === "Admin",
                      ) !== undefined
                    ) {
                      handleUnMatchStatement(selectedCardIds);
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "RMapping",
                        },
                      });
                    }
                  }
                } else {
                  if (
                    selectedCardIds?.length >
                    GlobalConfiguration.lengthCheckZero
                  ) {
                    if (
                      services?.find(
                        (service) =>
                          service === "AMapping" || service === "Admin",
                      ) !== undefined
                    ) {
                      handleMatchStatement(selectedCardIds);
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "AMapping",
                        },
                      });
                    }
                  }
                }
              }}
              enabledBgColor={
                selectedCardIds?.length > GlobalConfiguration.lengthCheckZero
                  ? "var(--positive-act)"
                  : "var(--text-disabled)"
              }
              hoverOption={"dark"}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
              isDisabled={
                !selectedCardIds?.length > GlobalConfiguration.lengthCheckZero
              }
              disabledTextColor={""}
              isLoading={unmatchLoader || matchLoader ? true : false}
              disabledBgColor={""}
              fullWidthRequired={true}
              isbottomSectionneed={
                remType === "remitterUnmatch" || remType === "remitterMatch"
              }
              bottomHeaderTextNeed={true}
              confirmbtnrequired={
                remType === "remitterUnmatch" || remType === "remitterMatch"
              }
              inActiveVariantNeeded
              bottomHeaderText={
                remType === "remitterUnmatch"
                  ? "To unmatch the transactions, select the accounts listed above and click “Unmatch”. The selected accounts will be unmatched with the transactions."
                  : remType === "remitterMatch"
                    ? "To match the transactions, select the accounts listed above and click “Match”. The selected accounts will be matched with the transactions."
                    : "To match the transactions, select the accounts listed above and click “Confirm.” The selected accounts will be matched with the transactions."
              }
              btnText={
                remType === "remitterUnmatch"
                  ? "Unmatch"
                  : remType === "remitterMatch"
                    ? "Match"
                    : "Confirm"
              }
              isfullViewrequired={remType === "remitterMatch" && true}
              fullviewbtnText="Register a new account"
              redirectHeader="Register a new account"
              fullviewhandleFunction={() => {
                navigate("/remitter_account_dashboard/create_remitter_account");
              }}
              smallPopupHeader="Confirm leaving this page?"
              redirectIcon={
                "https://q2pay.in/new_assets/common/settings/add_button_white.svg"
              }
            >
              <RemitterAccountViewAll
                remid={
                  totalRemiAccount?.length > GlobalConfiguration.lengthCheckZero
                    ? totalRemiAccount?.[0]
                    : unmatchRemiId?.length >
                        GlobalConfiguration.lengthCheckZero
                      ? unmatchRemiId
                      : matchRemiId?.length >
                          GlobalConfiguration.lengthCheckZero
                        ? matchRemiId
                        : ""
                }
                type={"RemitterAcc"}
                remType={remType}
                remiAcoountId={remiAcoountId}
                onCardNavigate={
                  remType !== "remitterUnmatch" &&
                  remType !== "remitterMatch" &&
                  handleCardNavigate
                }
                handleConfirmBtnClick={(e) => {}}
                selectedCardIds={selectedCardIds}
                setSelectedCardIds={setSelectedCardIds}
                cardType={
                  remType === "remitterUnmatch" || remType === "remitterMatch"
                    ? "matchRemAcc"
                    : ""
                }
                createDisabled={false}
                showModalPopup={true}
              />
            </LargePopupRedirect>
          </div>
        </>
      )}

      {showDescriptionPopup && (
        <div
          style={{ zIndex: "var(--z-index-modal)" }}
          className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center bg-opacity-dark-opacity"
        >
          <SmallPopupWithInput
            headerTitle="Description"
            headerFontColor="text-primary"
            headerFontWeight="semibold"
            textSize="font-md"
            subtext="Provide custom description."
            inputIsFullWidth={true}
            inputBgColor="var(--primary-bg)"
            inputPlaceholder="Description"
            // noteText="Minimum 10 characters required."
            bulletPoints={[
              "This description will be used for easier tracking and reconciliation of transaction entries.",
            ]}
            inputFgColor={
              description?.length
                ? "var(--text-primary)"
                : "var(--text-secondary)"
            }
            inputVariant={computeVariant(description, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            inputValue={description}
            inputFontKind="medium"
            inputOnInput={(e) => {
              if (
                e.target.value?.replace(/\s+/g, " ").trimStart()?.length <=
                GlobalConfiguration.inputMaxLength
              )
                setDescription(
                  e.target.value?.replace(/\s+/g, " ").trimStart(),
                );
            }}
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneHandleFunction={() => {
              if (!ownerItemizedAddDescriptionLoading) {
                setShowDescriptionPopup(false);
                setDescription("");
                setCurrentDescription({});
              }
            }}
            btnOneEnabledBgColor="transparent"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={ownerItemizedAddDescriptionLoading}
            btnOneHoverOption="white"
            btnTwoText={
              currentDescription?.description?.length ? "Confirm" : "Add"
            }
            btnTwoBtnType="button"
            btnTwoHandleFunction={async () => {
              if (!ownerItemizedAddDescriptionLoading) {
                let response = await dispatch(
                  addItemizedStatementDescription({
                    id: currentDescription.acc_id,
                    statement_entry_id:
                      currentDescription.ecollection_callback_id,
                    description: description,
                  }),
                );
                if (response?.payload?.status)
                  dispatch(
                    updateItemizedStatementData({
                      description: description,
                      ecollection_callback_id:
                        currentDescription.ecollection_callback_id,
                    }),
                  );
                setCurrentDescription({});
                setIsEditDescription(false);
                setShowDescriptionPopup(false);
                setDescription("");
              }
            }}
            btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoDisabledTextColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              (!isEditDescription && !description?.length) ||
              description === currentDescription?.description
            }
            btnTwoIsLoading={ownerItemizedAddDescriptionLoading}
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}

      {openMatchPopup && (
        <>
          <div style={{ zIndex: "var(--z-index-modal)" }}>
            <RemitAccountViewAllPopup
              id={remiAcoountId}
              type={"RemitterAcc"}
              headerTitle={"Match remitter accounts"}
              headersubtext={
                "Only active (pending & approved) accounts are enabled for selection."
              }
              closePopup={() => setOpenMatchPopup(false)}
              handleConfirmBtnClick={(e) => {
                handleMatchStatement(e);
              }}
              btnText={"Match"}
              cardType={"matchRemAcc"}
              bottomHeaderText={
                "To match the transactions, select the accounts listed above and click “Match.” The selected accounts will be matched with the transactions."
              }
              isfullViewrequired={true}
              fullviewbtnText="Register a new account"
              redirectHeader="Register a new account"
              fullviewhandleFunction={() => {
                navigate("/remitter_account_dashboard/create_remitter_account");
              }}
              redirectIcon={
                "https://q2pay.in/new_assets/common/settings/add_button_white.svg"
              }
              createDisabled={false}
              smallPopupHeader={"Confirm leaving this page?"}
              showModalPopup={true}
            />
          </div>
        </>
      )}

      {showOwnerPopup && (
        <div
          style={{ zIndex: "var(--z-index-modal)" }}
          className="fixed top-top-base left-left-base w-width-full h-height-full bg-Primary-black bg-opacity-light-opacity"
        >
          <OwnerAccountPopUp
            setIsSidebarOpen={filterOpen}
            setOpenOwner={() => {
              // setAccountNumber(accountnumberstate);
              setShowOwnerPopup(false);
            }}
            onClosed={() => setShowOwnerPopup(false)}
            accountNumber={accountNumber}
            setAccountNumber={setAccountNumber}
            accountnumberstate={accountnumberstate}
            setaccountnumberstate={setaccountnumberstate}
            multiSelect={true}
            setDefaultAccountNumber={setDefaultAccountNumber}
            accountDefaultNumber={accountDefaultNumber}
            flow={"txnViewAll"}
            popType={"ownerStatement"}
          />
        </div>
      )}

      <div
        className={` bg-custom-appBack flex flex-col overflow-hidden ${props?.flow === "rejectStatementdetails" && "relative"} ${props?.popType == "ownerStatement" ? " flex-1" : props?.popType ? "h-full" : "h-full-height"}`}
        style={{
          overflow: filterOpen && "hidden",
          overflowY: showCalendar && "overlay",
        }}
      >
        <div
          className={`hidden ${props?.popType == "ownerStatement" || props?.popType ? "hidden" : "Qsmd:block"} `}
          style={{
            minHeight:
              props?.popType == "ownerStatement" || props?.popType
                ? "var(--navbar-height)"
                : "var(--navbar-breadcrumb-height)",
            backgroundColor: "var(--primary-nav)",
            zIndex: "var(--z-index-header)",
          }}
        ></div>
        <div
          className={`${
            props?.popType == "ownerStatement" || props?.popType
              ? "itemised-owner_div_container-popup"
              : "itemised-owner_div_container"
          }`}
        >
          <StatementTopNavComponent
            loading={false}
            topNavCtaBtn1Props={
              matchButton
                ? {
                    btnText:
                      selectStatementRow?.length >
                      GlobalConfiguration.lengthCheckZero
                        ? "Clear"
                        : "Cancel",
                    btnType: "button",
                    enabledBgColor: "var(--primary-nav-act)",
                    handleFunction: (e) => {
                      setUnMatchStatement("");
                      setMatchStatement("");
                      if (
                        selectStatementRow?.length >
                        GlobalConfiguration.lengthCheckZero
                      ) {
                        setSelectStatementRow([]);
                      } else {
                        setFlowType("");
                        setMatchButton(false);
                        setMatchRemiId([]);
                        setTotalRemiAccount([]);
                        setSelectedCardIds([]);
                        setSelectStatementRow([]);
                        setSelectStatementType(false);
                        setPageSize(PaginationConfiguration.paginationSmall);
                      }
                    },

                    enabledTextColor: "var(--text-primary)",
                    isDisabled: false,
                    hoverOption: "white",
                  }
                : undefined
            }
            downloadFileProps={
              !matchButton
                ? {
                    btnText: "Download statement",
                    dropdownOptions: ["XLSX", "CSV", "TSV", "PDF"],
                    icon: "https://q2pay.in/new_assets/common/view_all/download_statement.svg",
                    isDisabled:
                      props?.popType && props?.flow !== "ownerDetail"
                        ? true
                        : isDisabled ||
                          showAdditionalDetails ||
                          filterOpen ||
                          showCalendar ||
                          !(type === "remitter_details" ||
                          props?.flow === "remitter_details" ||
                          props?.flow === "rejectStatementdetails"
                            ? getAssociatedItemisedData?.ecollection_callbacks
                                ?.length
                            : ownerAllAccItemisedData?.ecollection_callbacks
                                ?.length),
                    handleFunction: (e) => {
                      if (props?.popType && props?.flow !== "ownerDetail") {
                        actionRestricted()
                      } else {
                        if (
                          ownerAllAccItemisedData === null ||
                          ownerAllAccItemisedData?.total_count ===
                            GlobalConfiguration.lengthCheckZero ||
                          getAssociatedItemisedData?.ecollection_callbacks
                            ?.length === GlobalConfiguration.lengthCheckZero
                        ) {
                          e.stopPropagation();
                          return;
                        } else {
                          downloadStatement();
                        }
                      }
                    },
                    selectedOption: selectedType,
                    setSelectedOption: setSelectedType,
                  }
                : false
            }
            iconRoundProps={{
              enabledBgColor: "var(--primary-bg)",
              isLoading: loading,
              handleFunction: (e) => {
                if (props?.flow === "rejectStatementdetails") {
                  actionRestricted();
                } else if (!accountNumber.length) {
                  return;
                } else {
                  move();
                  fetchData();
                }
              },
              isDisabled:
                props?.flow === "rejectStatementdetails" ||
                !accountNumber.length
                  ? true
                  : false,
              icon: ICONS.RELOAD_REFRESH_WHITE,
              title: "Refresh all balances",
              hoverOption: "white",
            }}
            topNavCtaBtn2Props={
              matchButton
                ? {
                    btnText: matchCondition ? "Match" : "Confirm",
                    btnType: "button",
                    isLoading: matchLoader,
                    isLoaderNeeded: true,
                    enabledBgColor:
                      selectStatementRow?.length >
                        GlobalConfiguration.lengthCheckZero && !matchCondition
                        ? "var(--text-primary)"
                        : matchCondition &&
                            selectStatementRow?.length >
                              GlobalConfiguration.lengthCheckZero
                          ? "var(--positive-act)"
                          : "var(--text-disabled)",
                    handleFunction: (e) => {
                      if (
                        selectStatementRow?.length >
                        GlobalConfiguration.lengthCheckZero
                      ) {
                        if (matchCondition) {
                          handleMatchStatement(matchId);
                        } else {
                          setShowRemiAccounts(true);
                          setRemType("remitterMatch");
                        }
                      }
                    },
                    inActiveVariantNeeded: true,
                    enabledTextColor:
                      selectStatementRow?.length >
                        GlobalConfiguration.lengthCheckZero && !matchCondition
                        ? "var(--primary-bg)"
                        : matchCondition &&
                            selectStatementRow?.length >
                              GlobalConfiguration.lengthCheckZero
                          ? "var(--text-primary)"
                          : "var(--text-primary)",
                    isDisabled:
                      selectStatementRow?.length ===
                      GlobalConfiguration.lengthCheckZero,

                    hoverOption: "black",
                  }
                : false
            }
            BottomSubTextVaraint={"primary"}
            BottomHeader={
              matchButton ? (
                <>
                  Select transactions to match to
                  <span
                    className={`${remitterName ? "font-semibold" : "font-normal"} ml-margin-xs`}
                  >
                    {remitterName || "remitter accounts"}
                  </span>
                  . Auto-refresh is unavailable while matching remitters.
                </>
              ) : (
                <>
                  Statement updated as per bank :{" "}
                  {new Date()
                    .toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })
                    .replace(" ", " ")
                    .replace(/(\w{3}) (\d{4})/, "$1, $2")}
                  {!isToday(endDateState) || accountNumber?.length ? "," : ""}{" "}
                  {!isToday(endDateState)
                    ? "auto-refresh is unavailable for past date ranges."
                    : ""}
                </>
              )
            }
            countDownTimer={isToday(endDateState) && accountNumber?.length}
            countDownTimerDisabled={!accountNumber?.length || matchButton}
            resetCountDownTimer={resetTrigger}
            selectionText={`Transactions selected : ${totalSelectedCount}`}
            selectionBtnProps={{
              btnText: `Select up to ${pageSize}`,

              btnType: "button",

              handleFunction: () => {
                if (matchLoader) {
                  return;
                } else {
                  const callbacks =
                    type === "remitter_details" ||
                    props?.flow === "remitter_details" ||
                    props?.flow === "rejectStatementdetails"
                      ? getAssociatedItemisedData?.ecollection_callbacks
                      : ownerAllAccItemisedData?.ecollection_callbacks;

                  const visibleRows =
                    callbacks?.map((item, index) => ({
                      rowId:
                        item?.ecollection_callback_id ||
                        item?.id ||
                        `${currentPage}-${index}`,
                      callback: item,
                    })) || [];

                  if (shouldClearPreviousSelection) {
                    setSelectStatementRow(selectedLiveStatement || []);

                    setSelectedStatementRemitters({});

                    const additionalIds = Array.isArray(remiAcoountId)
                      ? remiAcoountId
                      : remiAcoountId
                        ? [remiAcoountId]
                        : [];

                    setMatchRemiId(additionalIds);

                    setSelectedCardIds(additionalIds);

                    return;
                  }

                  setSelectStatementRow((prev) => {
                    const selectableRows = visibleRows.filter(
                      ({ rowId }) => !selectedLiveStatement?.includes(rowId),
                    );

                    const selectableRowIds = selectableRows.map(
                      ({ rowId }) => rowId,
                    );

                    const totalUserSelectedCount = prev.filter(
                      (id) => !selectedLiveStatement?.includes(id),
                    ).length;

                    const shouldClearAll =
                      currentPageSelectedCount ===
                        currentPageSelectableIds.length &&
                      currentPageSelectableIds.length > 0;

                    if (shouldClearAll) {
                      setSelectedStatementRemitters({});

                      const additionalIds = Array.isArray(remiAcoountId)
                        ? remiAcoountId
                        : remiAcoountId
                          ? [remiAcoountId]
                          : [];

                      setMatchRemiId(additionalIds);
                      setSelectedCardIds(additionalIds);

                      return [];
                    }

                    const protectedRows = prev.filter((id) =>
                      selectedLiveStatement?.includes(id),
                    );

                    const rowsToSelect = selectableRowIds
                      .filter((id) => !prev.includes(id))
                      .slice(0, remainingSelection);

                    const updatedRows = [
                      ...new Set([
                        ...protectedRows,
                        ...prev.filter(
                          (id) => !selectedLiveStatement?.includes(id),
                        ),
                        ...rowsToSelect,
                      ]),
                    ];

                    setSelectedStatementRemitters((prevRemitters) => {
                      const updatedRemitters = {};

                      Object.keys(prevRemitters || {}).forEach((key) => {
                        if (selectedLiveStatement?.includes(key)) {
                          updatedRemitters[key] = prevRemitters[key];
                        }
                      });

                      selectableRows.forEach(({ rowId, callback }) => {
                        updatedRemitters[rowId] =
                          callback?.remitter_accounts?.map(
                            (acc) => acc.remitter_account_id,
                          ) || [];
                      });

                      const additionalIds = Array.isArray(remiAcoountId)
                        ? remiAcoountId
                        : remiAcoountId
                          ? [remiAcoountId]
                          : [];

                      const uniqueIds = [
                        ...new Set([
                          ...Object.values(updatedRemitters).flat(),
                          ...additionalIds,
                        ]),
                      ];

                      setMatchRemiId(uniqueIds);

                      return updatedRemitters;
                    });

                    return updatedRows;
                  });

                  setSelectedCardIds(
                    Array.isArray(remiAcoountId)
                      ? remiAcoountId
                      : remiAcoountId
                        ? [remiAcoountId]
                        : [],
                  );
                }
              },

              enabledBgColor:
                isAllVisibleSelected &&
                !loading &&
                !ownerAllAccItemisedLoading &&
                !getAssociatedItemisedLoading
                  ? "var(--positive-bg)"
                  : "var(--primary-nav-act)",

              hoverOption: isAllVisibleSelected ? "black" : "white",

              enabledTextColor: "var(--text-primary)",

              isDisabled:
                ownerAllAccItemisedLoading ||
                getAssociatedItemisedLoading ||
                matchLoader ||
                loading,

              icon:
                isAllVisibleSelected && !loading && !ownerAllAccItemisedLoading
                  ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                  : ICONS.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
            }}
            // matchBtnProps={
            //   matchButton
            //     ? {
            //         btnText: "Matched : 0",
            //         btnType: "button",
            //         handleFunction: () => {
            //           if (matchStatement === "") {
            //             setMatchStatement("Matched");
            //             setUnMatchStatement("");
            //           } else {
            //             setMatchStatement("");
            //           }
            //         },
            //         enabledBgColor:
            //           matchStatement === ""
            //             ? "var(--primary-nav-act)"
            //             : "var(--primary-card)",
            //         hoverOption: "white",
            //         enabledTextColor: "var(--text-primary)",
            //         isDisabled: false,
            //         icon:
            //           matchStatement === ""
            //             ? ICONS?.FILTER
            //             : ICONS.CLOSE_WITH_BLUE_CIRCLE,
            //         imgColor:
            //           matchStatement === "" ? "var(--text-primary)" : "",
            //       }
            //     : undefined
            // }
            // unmatchBtnProps={
            //   matchButton
            //     ? {
            //         btnText: "Unmatched : 0",
            //         btnType: "button",
            //         handleFunction: () => {
            //           if (unmatchStatement === "") {
            //             setUnMatchStatement("Unmatched");
            //             setMatchStatement("");
            //           } else {
            //             setUnMatchStatement("");
            //           }
            //         },
            //         enabledBgColor:
            //           unmatchStatement === ""
            //             ? "var(--primary-nav-act)"
            //             : "var(--primary-card)",
            //         hoverOption: "white",
            //         enabledTextColor: "var(--text-primary)",
            //         isDisabled: false,
            //         icon:
            //           unmatchStatement === ""
            //             ? ICONS?.FILTER
            //             : ICONS.CLOSE_WITH_BLUE_CIRCLE,
            //         imgColor:
            //           unmatchStatement === "" ? "var(--text-primary)" : "",
            //       }
            //     : undefined
            // }
            matchRemitterProps={
              !matchButton && props?.flow !== "rejectStatementdetails"
                ? {
                    handleFunction: () => {
                      if (props?.popType) {
                       actionRestricted()
                      } else {
                        if (hasMatchPermission) {
                          if (
                            !accountNumber.length ||
                            ownerAllAccItemisedLoading ||
                            statementType === "Debit"
                          ) {
                            return;
                          } else {
                            setMatchButton(!matchButton);
                          }
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AMapping",
                            },
                          });
                        }
                      }
                    },
                    isDisabled:
                      !hasMatchPermission || statementType === "Debit"
                        ? true
                        : props?.popType
                          ? true
                          : !accountNumber.length || ownerAllAccItemisedLoading,
                    enabledBgColor: "var(--primary-bg)",
                    isLoading: false,
                    imgColor: "var(--text-primary)",
                    hoverOption: "white",
                    buttonRef: null,
                    title:
                      "Match a remitter account to identify the source of credited transactions.",
                  }
                : undefined
            }
            isSelectionView={matchButton ? true : false}
            filteredSearchProps={{
              isFilterDisabled:
                props?.statement_entry_id || !accountNumber.length,
              isColumnDisabled: props?.statement_entry_id
                ? true
                : !accountNumber.length,
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: true,

              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              statementType: statementType,
              searchPlaceholder: "Search consolidated live statement",
              columnOptions: [
                { colName: "Bank", colWidth: "column-width-sm", flex: 0 },
                {
                  colName: "Transaction date",
                  colWidth: "column-width-md",
                  flex: 0,
                },
                {
                  colName: "Value date",
                  colWidth: "column-width-md",
                  flex: 0,
                },
                {
                  colName: "Party name",
                  colWidth: "column-width-lg",
                  flex: 1,
                },
                { colName: "Amount", colWidth: "column-width-md", flex: 0 },
                {
                  colName: "Narration",
                  colWidth: "column-width-lg",
                  flex: 1,
                },
                {
                  colName: "Bank reference",
                  colWidth: "column-width-md",
                  flex: 0,
                },
                {
                  colName: "Party account number",
                  colWidth: "column-width-md",
                  flex: 0,
                },
                {
                  colName: "Party IFSC",
                  colWidth: "column-width-md",
                  flex: 0,
                },
                {
                  colName: "Description",
                  colWidth: "column-width-lg",
                  flex: 1,
                },

                {
                  colName: "Remitter account",
                  colWidth: "column-width-md",
                  flex: 0,
                  isDisabled: statementType === "Debit" ? true : false,
                },
              ],

              filterItems: [
                {
                  name: "Credit amount",
                  short_name: "Cr. Amt. -",
                  isMulti: false,
                  value: creditAmount,
                  setValue: (val) => {
                    setCreditAmount(val);
                    // setSearchUserText(val);
                    // handleSubmit("search", val);
                  },
                  isDropdown: false,
                  isDisabled:
                    ownerAllAccItemisedLoading ||
                    props?.popType === "ownerStatement" ||
                    props?.flow === "rejectStatementdetails",
                  valueType: "string",
                },
              ],

              columnValue: additionalDetailColState,
              columnHandleChange: (val) => {
                handleAddDetail(val ? val : defaultAdditionalDetailCol);
              },
              isColumnDefaultDisabled:
                JSON.stringify(
                  defaultAdditionalDetailCol?.filter(
                    (itm) =>
                      itm.colName !==
                      (statementType === "Debit" ? "Remitter account" : ""),
                  ),
                ) === JSON.stringify(additionalDetailColState) ||
                JSON.stringify(
                  defaultAdditionalDetailCol?.filter(
                    (itm) =>
                      itm.colName !==
                      (statementType === "Debit" ? "Remitter account" : ""),
                  ),
                ) === JSON.stringify(additionalDetailColState),
              handleColumnDefault: () => {
                if (statementType === "Debit") {
                  setAdditionalDetailsColState(
                    defaultAdditionalDetailCol.filter(
                      (itm) => itm.colName !== "Remitter account",
                    ),
                  );
                } else {
                  setAdditionalDetailsColState(defaultAdditionalDetailCol);
                }
              },

              filters: [
                {
                  name: "Owner account",
                  filterType: "accountSelect",
                  btnProps: {
                    btnText: accountnumberstate.length
                      ? `${accountnumberstate.length} selected`
                      : "Select accounts",
                    enabledTextColor: "var(--text-primary)",
                    enabledBgColor: "var(--primary-nav-act)",
                    isDisabled:
                      props?.flow === "rejectStatementdetails" ||
                      props?.flow === "ownerDetail",
                    handleFunction: () => {
                      if (
                        props?.popType !== "ownerStatement" &&
                        props?.flow !== "ownerDetail"
                      ) {
                        if (props?.flow !== "rejectStatementdetails") {
                          setShowOwnerPopup(true);
                        }
                      }
                    },
                  },
                },
                {
                  name: "Amount range",
                  filterType: "amountRange",
                  variant: "single",
                  size: "small",
                  value: isAmtFilterApplied,
                  rangeValue: amountRangeFilter,
                  setShowAmtFilterDiv: setShowAmtFilterDiv,
                  setIsAmtFilterApplied: setIsAmtFilterApplied,
                  handleChange: (val) => {
                    if (typeof val === "function") {
                      setAmountRangeFilter((prev) => val(prev));
                      return;
                    }

                    if (val && typeof val === "object") {
                      const nextMin = val?.min ?? "";
                      const nextMax = val?.max ?? "";
                      setAmountRangeFilter({
                        min: nextMin,
                        max: nextMax,
                      });
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("min_amount", nextMin);
                      handleSubmit("max_amount", nextMax);
                      return;
                    }

                    setAmountRangeFilter({ min: "", max: "" });
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit("min_amount", "");
                    handleSubmit("max_amount", "");
                  },
                },

                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateState && endDateState,
                  isDisable: false,
                  startDate: startDateState
                    ? new Date(
                        startDateState * IntervalConfiguration.intervalMedium,
                      )
                    : startDateState,

                  endDate: endDateState
                    ? new Date(
                        endDateState * IntervalConfiguration.intervalMedium,
                      )
                    : endDateState,

                  handleChange: (date) => {
                    setIsDateConfirm(date ? true : false);
                    handleDateChange(date);
                  },
                },
                {
                  name: "Match status",
                  filterType: "dropdown",
                  variant: "single",
                  options: ["Matched", "Unmatched"],
                  size: "small",
                  value: matchStatement || unmatchStatement,
                  dropdownPlaceHolder: "Select status",
                  isDisabled: props?.flow === "rejectStatementdetails",

                  statusPop: true,
                  handleChange: (value) => {
                    if (value === "Matched") {
                      setMatchStatement(value);
                      setUnMatchStatement("");
                    } else {
                      setUnMatchStatement(value);
                      setMatchStatement("");
                    }
                    move();
                  },
                },
              ],
              isFilterClearAllDisabled:
                props?.flow === "rejectStatementdetails"
                  ? !amountRangeFilter?.min &&
                    !amountRangeFilter?.max &&
                    !startDateState &&
                    !endDateState
                  : !matchStatement?.length &&
                    !unmatchStatement?.length &&
                    !amountRangeFilter?.min &&
                    !amountRangeFilter?.max &&
                    startDateState === defaultStartDate &&
                    endDateState === defaultEndDate &&
                    !isDateConfirm,

              isSearchClearAllDisabled: false,
              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: ownerAllAccItemisedLoading,
              setLoading: setLoadingData,
              isShowFilter: true,
              isShowColumn: true,
              loadingData: loadingData,
            }}
            typeToggleState={statementType}
            typeToggleSetter={(val) => {
              handleAddDetail("Remitter account");
              setStatementType(val);
              setCurrentPage(GlobalConfiguration.lengthCheckOne);
            }}
            isTypeToggleDisabled={
              ownerAllAccItemisedLoading || !accountNumber.length || matchButton
            }
            openFilter={openDateFilter}
            setOpenFilter={setopenDateFilter}
            ispagination={
              (type === "remitter_details" ||
              props?.flow === "remitter_details" ||
              props?.flow === "rejectStatementdetails"
                ? getAssociatedItemisedData?.ecollection_callbacks?.length
                : ownerAllAccItemisedData?.ecollection_callbacks?.length) >
                GlobalConfiguration.lengthCheckZero && matchButton
                ? true
                : false
            }
          />
        </div>

        <div
          style={{
            position: showInnerSearchBar ? "absolute" : "relative",
            opacity: showInnerSearchBar
              ? "var(--dark-opacity)"
              : "var(--opcacity_none)",
            display: showInnerSearchBar ? "block" : "hidden",
            backgroundColor: showInnerSearchBar ? "var(--PopUp-BackDrop)" : "",
            height: showInnerSearchBar ? "var(--height-full)" : "0",
            width: showInnerSearchBar ? "var(--width-full)" : "0",
            zIndex: "var(--z-index-content)",
          }}
        ></div>

        <div
          ref={scrollRef}
          style={{
            backgroundColor: "var(--primary-bg)",
            overflowY: "hidden",
            overflowX: (
              type === "remitter_details" ||
              props?.flow === "remitter_details" ||
              props?.flow === "rejectStatementdetails"
                ? getAssociatedItemisedLoading ||
                  !getAssociatedItemisedData?.ecollection_callbacks?.length
                : ownerAllAccItemisedLoading ||
                  !ownerAllAccItemisedData?.ecollection_callbacks?.length
            )
              ? "hidden"
              : "scroll",
            marginBottom:
              ownerAllAccItemisedLoading || getAssociatedItemisedLoading
                ? ""
                : ((type === "remitter_details" ||
                      props?.flow === "remitter_details") &&
                    props?.flow !== "rejectStatementdetails"
                      ? getAssociatedItemisedData?.ecollection_callbacks?.length
                      : ownerAllAccItemisedData?.ecollection_callbacks
                          ?.length) > GlobalConfiguration.lengthCheckZero
                  ? "var(--pagination-height)"
                  : "",
            borderRadius: "inherit",
            width:
              props?.popType == "ownerStatement" || props?.popType
                ? "var(--popup-width)"
                : "var(--full-width)",
          }}
          className={`${
            props?.popType == "ownerStatement" || props?.popType
              ? "popupstatementviewallscrolls"
              : ""
          } overflow-x-auto flex flex-col  statementviewallscroll   flex-1`}
        >
          <div
            style={{
              display:
                !(type === "remitter_details" ||
                props?.flow === "remitter_details" ||
                props?.flow === "rejectStatementdetails"
                  ? getAssociatedItemisedData?.ecollection_callbacks?.length
                  : ownerAllAccItemisedData?.ecollection_callbacks?.length) ||
                ownerAllAccItemisedLoading ||
                getAssociatedItemisedLoading
                  ? "none"
                  : "",
              background: !ownerAllAccItemisedData?.ecollection_callbacks
                ?.length
                ? "var(--primary-bg)"
                : !getAssociatedItemisedData?.ecollection_callbacks?.length
                  ? "var(--primary-bg)"
                  : "var(--primary-nav)",
              zIndex: openMatchPopup
                ? "var(--z-index-base)"
                : showCalendar || filterOpen || showAdditionalDetails
                  ? "var(--z-index-base)"
                  : "var(--z-index-fixed-ui)",
              width:
                props?.popType == "ownerStatement" || props?.popType
                  ? "var(--popup-width)"
                  : "var(--width-full)",
              bottom:
                props?.flow === "rejectStatementdetails"
                  ? "var(--bottom-base)"
                  : props?.popType == "ownerStatement" || props?.popType
                    ? "var(--bottom-sm)"
                    : "var(--bottom-base)",
              borderRadius:
                props?.popType == "ownerStatement" || props?.popType
                  ? " var(--border-radius-md)"
                  : "none",
              pointerEvents: showInnerSearchBar && "none",
            }}
            className={`fixed w-width-full ${props?.flow === "rejectStatementdetails" || props?.flow !== "ownerDetail" ? "absolute" : "fixed"} ${
              (props?.popType == "ownerStatement" || props?.popType) &&
              props?.flow !== "ownerDetail"
                ? "ownerdetailsresponsivestatement"
                : ""
            }`}
          >
            <div
              className={` ${
                showInnerSearchBar &&
                " absolute opacity-light-opacity w-full h-full z-z-index-header bg-PopUp-BackDrop pointer-events-none "
              }`}
            ></div>
            <PaginationComponent
              handleSelect={handleSelect}
              selectedValue={selectedValue}
              data={ownerAllAccItemisedData || getAssociatedItemisedData || []}
              pageSize={pageSize}
              dropdownOptions={dropdownOptions}
              handlePagination={handlePagination}
              currentPage={currentPage}
              setIsOpen={setIsOpen}
              typePopup={
                props?.flow === "rejectStatementdetails"
                  ? false
                  : props?.popType == "ownerStatement" || props?.popType
                    ? true
                    : false
              }
            />
          </div>

          <div
            className={`w-max min-w-full z-z-index-content  ${showInnerSearchBar && " opacity-light-opacity bg-PopUp-BackDrop"} `}
          >
            <div
              className={`itemised-table-div-container ${showInnerSearchBar && " opacity-light-opacity bg-PopUp-BackDrop"}  `}
            >
              {matchButton && (
                <>
                  {" "}
                  <div>
                    {" "}
                    <p
                      className={`text-font-xs px-padding-xl h-auto break-all py-padding-button-l border-r border-primary-bg text-text-secondary text-center`}
                    >
                      Select
                    </p>
                  </div>
                </>
              )}

              {additionalDetailColState?.map((column, index) => {
                return (
                  <>
                    <p
                      style={{
                        minWidth: `var(--${column.colWidth})`,
                        flex: `${column.flex}`,
                      }}
                      className={`text-font-xs px-padding-md h-auto py-padding-button-l text-text-secondary text-center`}
                    >
                      {column.colName === "Amount"
                        ? statementType === "Credit"
                          ? "Credit amount"
                          : "Debit amount"
                        : column.colName}
                    </p>
                    <div
                      style={{
                        display:
                          index === additionalDetailColState.length - 1
                            ? "none"
                            : "block",
                      }}
                      className="itemised-border-mid-div"
                    ></div>
                  </>
                );
              })}
            </div>
          </div>

          {!accountNumber.length ? (
            <div className="h-height-full flex-col m-auto pb-padding-md  overflow-y-scroll justify-center items-center flex w-full">
              <img
                style={{
                  marginBottom: "var(--margin-xl)",
                  paddingTop: "var(--padding-xl)",
                }}
                src={ICONS?.VIEW_CATEGORY_GRAPHICS}
                alt="No accounts found"
                className="statement_noacc_found"
              />
              <p className="select_text flex flex-col">
                <span>Select the accounts to view live statement.</span>
              </p>
              <div>
                <PrimaryButton
                  enabledBgColor="var(--primary-act)"
                  btnText="Select accounts"
                  enabledTextColor="var(--text-primary)"
                  handleFunction={() => {
                    setShowOwnerPopup(true);
                  }}
                  buttonRef={selectAccountRef}
                  hoverOption="white"
                />
              </div>
            </div>
          ) : ownerAllAccItemisedLoading || getAssociatedItemisedLoading ? (
            <div
              className={`absolute top-auto flex h-height-lg m-auto justify-center items-center ${
                props?.popType === "ownerStatement"
                  ? "w-full-popup-width"
                  : "w-full-width"
              }`}
            >
              <Loader />
            </div>
          ) : ownerAllAccItemisedData?.total_count >
              GlobalConfiguration.lengthCheckZero ||
            (getAssociatedItemisedData?.ecollection_callbacks?.length &&
              flowType !== "remitter_details_match_statement" &&
              selectStatementType !== "remitter_edit_match_statement") ? (
            <>
              <div
                ref={scrollTopRef}
                style={{
                  flex: "1",

                  overflowY:
                    type === "remitter_details" ||
                    props?.flow === "remitter_details" ||
                    props?.flow === "rejectStatementdetails"
                      ? getAssociatedItemisedLoading ||
                        getAssociatedItemisedData?.owner_account_details
                          ?.statement?.length
                        ? "hidden"
                        : "auto"
                      : ownerAllAccItemisedLoading ||
                          ownerAllAccItemisedData?.owner_account_details
                            ?.statement?.length
                        ? "hidden"
                        : "auto",
                }}
                className={`${props?.popType === "ownerStatement" ? "" : "mb-margin-md"} overflow-y-scroll w-max min-w-full mb-margin-lg Qsmd:mb-margin-base pb-padding-xl Qsmd:pb-padding-base  mt-margin-base`}
              >
                {(
                  ownerAllAccItemisedData || getAssociatedItemisedData
                )?.ecollection_callbacks?.map((statement, index) => {
                  const rowId =
                    statement?.ecollection_callback_id ||
                    statement?.id ||
                    `${currentPage}-${index}`;

                  const isPreSelected = selectedLiveStatement.includes(rowId);
                  const isSelected =
                    isPreSelected || selectStatementRow.includes(rowId);
                  return (
                    <div
                      key={index}
                      onClick={() => {
                        if (!matchButton) return;

                        if (isPreSelected) {
                          CommonToast({
                            text: "Unmatching transactions are restricted in the matching flow.",
                            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                            variant: "var(--error)",
                          });
                          return;
                        }

                        const statementRemitterIds =
                          statement?.remitter_accounts?.map(
                            (itm) => itm.remitter_account_id,
                          ) || [];

                        const additionalIds = Array.isArray(remiAcoountId)
                          ? remiAcoountId
                          : remiAcoountId
                            ? [remiAcoountId]
                            : [];

                        const isSelected = selectStatementRow.includes(rowId);

                        const currentSelectedCount = selectStatementRow.filter(
                          (id) => !selectedLiveStatement?.includes(id),
                        ).length;

                        const maxLimit = Number(pageSize);

                        if (!isSelected && currentSelectedCount >= maxLimit) {
                          CommonToast({
                            text: "Maximum limit reached.",
                            icon: ICONS.ERROR_WITH_WHITE_CIRCLE,
                            variant: "var(--error)",
                            buttonNeeded: false,
                          });

                          return;
                        }

                        setSelectStatementRow((prev) =>
                          isSelected
                            ? prev.filter((id) => id !== rowId)
                            : [...prev, rowId],
                        );

                        setSelectedStatementRemitters((prev) => {
                          const updated = { ...prev };

                          if (isSelected) {
                            delete updated[rowId];
                          } else {
                            updated[rowId] = statementRemitterIds;
                          }

                          const uniqueIds = [
                            ...new Set([
                              ...Object.values(updated).flat(),
                              ...additionalIds,
                            ]),
                          ];

                          setMatchRemiId(uniqueIds);

                          return updated;
                        });

                        setSelectedCardIds(
                          Array.isArray(remiAcoountId)
                            ? remiAcoountId
                            : [remiAcoountId],
                        );
                      }}
                      className={`itemised-table-div-content
                         ${isPreSelected && matchButton && "opacity-light-opacity"}
                                 ${
                                   matchLoader && !isPreSelected
                                     ? "cursor-default opacity-50"
                                     : matchButton && !isPreSelected
                                       ? "cursor-pointer"
                                       : "cursor-default"
                                 }
                                ${
                                  isSelected && matchButton
                                    ? `bg-positive-bg ${!showInnerSearchBar && "z-z-index-content"}`
                                    : isSelected
                                      ? "global-hover-black"
                                      : matchButton
                                        ? `global-hover-white ${!showInnerSearchBar && "z-z-index-content"}`
                                        : ""
                                }
                                        `}
                    >
                      {matchButton && (
                        <>
                          {" "}
                          <div className="px-padding-xl flex items-center justify-center">
                            <img
                              src={
                                isSelected
                                  ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                                  : ICONS.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                              }
                              alt="selection"
                              className="h-icon-sm ml-margin-sm"
                            />
                          </div>
                        </>
                      )}
                      {additionalDetailColState?.some(
                        (x) => x.colName === "Bank",
                      ) && (
                        <>
                          <div className="text-font-xs flex-0 pr-padding-md pl-padding-lg h-auto py-padding-xs  text-text-secondary text-center min-w-column-width-sm w-column-width-sm flex items-center">
                            <div className="py-padding-button-s px-padding-sm rounded-border-radius-md bg-text-primary flex justify-center items-center">
                              <div className="w-banklogo-width-sm h-banklogo-height-sm flex-shrink-0">
                                <IfscCodeMapper
                                  ifscCode={statement?.party_ifsc}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {additionalDetailColState.some(
                        (x) => x.colName === "Transaction date",
                      ) && (
                        <>
                          <p
                            className={
                              "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-secondary text-center w-column-width-md min-w-column-width-md"
                            }
                          >
                            {statement?.transaction_date
                              ? formatDateandTime(statement?.transaction_date)
                              : "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailColState.some(
                        (x) => x.colName === "Value date",
                      ) && (
                        <>
                          <p
                            className={
                              "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-secondary text-center w-column-width-md min-w-column-width-md"
                            }
                          >
                            {statement?.value_date
                              ? formatDateandTime(statement?.value_date)
                              : "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailColState.some(
                        (x) => x.colName === "Party name",
                      ) && (
                        <>
                          <p className="text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-1 text-text-secondary text-center w-column-width-lg min-w-column-width-lg">
                            {statement?.party_name || "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailColState.some(
                        (x) => x.colName === `Amount`,
                      ) && (
                        <>
                          <div
                            className={
                              " text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-secondary text-center w-column-width-md min-w-column-width-md"
                            }
                            style={{
                              color:
                                statementType === "Credit"
                                  ? "var(--settled)"
                                  : "var(--failed)",
                              textAlign: "right",
                              justifyContent: "end",
                            }}
                          >
                            INR{" "}
                            <FormatAmount price={Number(statement?.amount)} />
                          </div>
                        </>
                      )}
                      {additionalDetailColState.some(
                        (x) => x.colName === "Narration",
                      ) && (
                        <>
                          <p
                            className={
                              "text-wrap  text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-1 text-text-secondary text-center w-column-width-lg min-w-column-width-lg"
                            }
                          >
                            {statement?.narration || "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailColState.some(
                        (x) => x.colName === "Bank reference",
                      ) && (
                        <>
                          <p
                            className={
                              "break-all text-wrap text-font-xs px-padding-md h-auto flex items-center justify-center py-padding-xs flex-0 text-text-secondary text-center w-column-width-md min-w-column-width-md"
                            }
                          >
                            {statement?.bank_reference || "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailColState.some(
                        (x) => x.colName === "Party account number",
                      ) && (
                        <>
                          <p
                            className={
                              "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-secondary text-center w-column-width-md min-w-column-width-md"
                            }
                          >
                            {statement?.party_account_number
                              ? formatAccountNumber(
                                  statement?.party_account_number,
                                )
                              : "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailColState.some(
                        (x) => x.colName === "Party IFSC",
                      ) && (
                        <>
                          <p className="text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-secondary text-center w-column-width-md min-w-column-width-md">
                            {statement?.party_ifsc || "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailColState.some(
                        (x) => x.colName === "Description",
                      ) && (
                        <div
                          className={
                            " px-padding-md h-auto flex items-center justify-center py-padding-xs flex-1 text-text-primary text-center w-column-width-lg min-w-column-width-lg"
                          }
                        >
                          {statement?.description?.length ? (
                            <div className="flex gap-x-gap-sm justify-center">
                              <p className="text-font-xs text-text-secondary break-all">
                                {linkIdentifier(statement?.description)}
                              </p>
                              <div className="border-r-border h-auto border-primary-act"></div>
                              <img
                                title="Edit"
                                src={ICONS?.EDIT}
                                alt="edit"
                                className={`h-icon-sm w-icon-sm flex-shrink-0 ${(props?.flow === "rejectStatementdetails" || matchButton) && "cursor-not-allowed opacity-light-opacity"} my-auto ${
                                  !services?.includes("ADescription") &&
                                  !services?.includes("Admin")
                                    ? "cursor-not-allowed opacity-light-opacity"
                                    : props?.flow === "rejectStatementdetails"
                                      ? "cursor-not-allowed"
                                      : "cursor-pointer"
                                } `}
                                onClick={() => {
                                  if (
                                    props?.flow === "rejectStatementdetails"
                                  ) {
                                    actionRestricted();
                                  } else if (
                                    !services?.includes("ADescription") &&
                                    !services?.includes("Admin")
                                  ) {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService:
                                          "ADescription,Admin",
                                      },
                                    });
                                  } else {
                                    if (!matchButton) {
                                      setIsEditDescription(true);
                                      setDescription(statement?.description);
                                      setCurrentDescription({
                                        acc_id: statement?.owner_account_id,

                                        description: statement?.description,
                                        ecollection_callback_id:
                                          statement?.ecollection_callback_id,
                                      });
                                      setShowDescriptionPopup(true);
                                    }
                                  }
                                }}
                              />
                            </div>
                          ) : (
                            <PrimaryWithIconButton
                              btnText="Add description"
                              outLineColor={"var(--text-primary)"}
                              btnType="button"
                              enabledBgColor="transparent"
                              enabledTextColor="var(--text-primary)"
                              hoverOption="white"
                              iconToBeAlign="left"
                              icon={ICONS?.ADD_BUTTON_WHITE}
                              imgColor="var(--text-primary)"
                              isDisabled={
                                props?.flow === "rejectStatementdetails"
                                  ? true
                                  : matchButton
                                    ? true
                                    : !services?.includes("ADescription") &&
                                      !services?.includes("Admin")
                              }
                              handleFunction={() => {
                                if (props?.flow === "rejectStatementdetails") {
                                  actionRestricted();
                                } else {
                                  if (!matchButton) {
                                    if (
                                      !services?.includes("ADescription") &&
                                      !services?.includes("Admin")
                                    ) {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService:
                                            "VAccountBalance,Admin",
                                        },
                                      });
                                    } else {
                                      setIsEditDescription(false);
                                      setShowDescriptionPopup(true);
                                      setCurrentDescription({
                                        acc_id: statement?.owner_account_id,

                                        description: statement?.description,
                                        ecollection_callback_id:
                                          statement?.ecollection_callback_id,
                                      });
                                    }
                                  }
                                }
                              }}
                            />
                          )}
                        </div>
                      )}

                      {props?.flow !== "rejectStatementdetails" && additionalDetailColState.some(
                        (x) => x.colName === "Remitter account",
                      ) && (
                        <div
                          className={
                            "  h-auto flex items-center justify-center py-padding-xs flex-1 text-text-primary text-center w-column-width-lg min-w-column-width-lg"
                          }
                        >
                          {statement?.remitter_accounts?.length ? (
                            <div className="flex gap-x-gap-xs w-full px-padding-md">
                              <div className="w-full justify-between items-center flex">
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (hasViewPermission) {
                                      if (
                                        props?.flow ===
                                          "rejectStatementdetails" ||
                                        props?.flow === "ownerDetail"
                                      ) {
                                        actionRestricted();
                                      } else {
                                        setShowRemiAccounts(true);
                                        setTotalRemiAccount([
                                          statement?.remitter_accounts?.map(
                                            (itm) => itm.remitter_account_id,
                                          ),
                                        ]);
                                      }
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "REVAccount",
                                        },
                                      });
                                    }
                                  }}
                                  className={` text-font-sm text-pending underline ${props?.flow === "rejectStatementdetails" || props?.flow === "ownerDetail" ? "opacity-light-opacity cursor-not-allowed " : !hasViewPermission ? "opacity-light-opacity cursor-not-allowed" : "cursor-pointer"} `}
                                >
                                  {`${statement?.remitter_accounts?.length}
                                                          matched`}
                                </div>

                                <div
                                  className={` rounded-border-radius-md ${matchButton ? "hidden" : "block"} cursor-pointer  `}
                                >
                                  <SecondaryAnimatedButton
                                    handleFunction={(e) => {
                                      e.stopPropagation();
                                      if (
                                        props?.flow ===
                                          "rejectStatementdetails" ||
                                        props?.flow === "ownerDetail"
                                      ) {
                                        actionRestricted();
                                      } else {
                                        if (!matchButton) {
                                          if (hasUnMatchPermission) {
                                            setShowRemiAccounts(true);
                                            setRemType("remitterUnmatch");
                                            setSelectStatementRow([
                                              statement?.ecollection_callback_id,
                                            ]);
                                            setUnmatchRemiId(
                                              statement?.remitter_accounts?.map(
                                                (itm) =>
                                                  itm.remitter_account_id,
                                              ),
                                            );
                                          } else {
                                            navigate("/feature_not_assigned", {
                                              state: {
                                                unavailableService: "RMapping",
                                              },
                                            });
                                          }
                                        }
                                      }
                                    }}
                                    isDisabled={
                                      props?.flow ===
                                        "rejectStatementdetails" ||
                                      props?.flow === "ownerDetail" ||
                                      !hasUnMatchPermission
                                    }
                                    enabledBgColor={"var(--primary-nav)"}
                                    disabledBgColor=""
                                    isLoading={false}
                                    icon={ICONS.UNMATCH}
                                    hoverOption="white"
                                    buttonRef={null}
                                    title="Unmatch remitter accounts from transaction"
                                    text={"Unmatch"}
                                    imgColor={"var(--text-primary)"}
                                  />
                                </div>
                              </div>

                              <div
                                className={` ${matchButton ? " hidden" : "flex"}`}
                              >
                                <div
                                  className={` rounded-border-radius-md  cursor-pointer ${matchButton ? "hidden" : "block"} flex  `}
                                >
                                  <SecondaryAnimatedButton
                                    handleFunction={(e) => {
                                      e.stopPropagation();

                                      if (
                                        props?.flow ===
                                          "rejectStatementdetails" ||
                                        props?.flow === "ownerDetail"
                                      ) {
                                        actionRestricted();
                                      } else {
                                        if (!matchButton) {
                                          if (hasMatchPermission) {
                                            setShowRemiAccounts(true);
                                            setRemType("remitterMatch");
                                            setSelectStatementRow([
                                              statement?.ecollection_callback_id,
                                            ]);

                                            setMatchRemiId([
                                              ...(statement?.remitter_accounts?.map(
                                                (itm) =>
                                                  itm.remitter_account_id,
                                              ) || []),
                                              ...(Array.isArray(remiAcoountId)
                                                ? remiAcoountId
                                                : remiAcoountId
                                                  ? [remiAcoountId]
                                                  : []),
                                            ]);

                                            setSelectedCardIds(
                                              Array.isArray(remiAcoountId)
                                                ? remiAcoountId
                                                : [remiAcoountId],
                                            );
                                          } else {
                                            navigate("/feature_not_assigned", {
                                              state: {
                                                unavailableService: "AMapping",
                                              },
                                            });
                                          }
                                        }
                                      }
                                    }}
                                    isDisabled={
                                      props?.flow ===
                                        "rejectStatementdetails" ||
                                      props?.flow === "ownerDetail" ||
                                      !hasMatchPermission
                                    }
                                    enabledBgColor={"var(--primary-nav)"}
                                    disabledBgColor=""
                                    isLoading={false}
                                    icon={ICONS.MATCH}
                                    hoverOption="white"
                                    buttonRef={null}
                                    title="Match remitter accounts to transaction"
                                    text={"Match"}
                                    imgColor={"var(--text-primary)"}
                                  />
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <PrimaryWithIconButton
                                btnText="Match remitter account"
                                outLineColor={"var(--text-primary)"}
                                btnType="button"
                                enabledBgColor="transparent"
                                enabledTextColor="var(--text-primary)"
                                hoverOption="white"
                                iconToBeAlign="left"
                                icon={ICONS.MATCHED_WITH_CIRCLE}
                                imgColor="var(--text-primary)"
                                isDisabled={
                                  !hasMatchPermission
                                    ? true
                                    : props?.flow ===
                                          "rejectStatementdetails" ||
                                        props?.flow === "ownerDetail"
                                      ? true
                                      : matchButton
                                        ? true
                                        : false
                                }
                                handleFunction={(e) => {
                                  e.stopPropagation();
                                  if (
                                    props?.flow === "rejectStatementdetails" ||
                                    props?.flow === "ownerDetail"
                                  ) {
                                    actionRestricted();
                                  } else {
                                    if (hasMatchPermission) {
                                      if (!matchButton) {
                                        setSelectStatementRow([
                                          statement?.ecollection_callback_id,
                                        ]);
                                        setOpenMatchPopup(true);
                                      }
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "AMapping",
                                        },
                                      });
                                    }
                                  }
                                }}
                              />
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <div
              className={`h-height-full flex-col m-auto  ${
                props?.popType === "ownerStatement"
                  ? "w-full-popup-width"
                  : "w-full-width"
              }  overflow-y-scroll justify-center items-center flex`}
            >
              <img
                src={ICONS?.NO_DATA_FOUND}
                alt="No accounts found"
                className="w-graphic-rectangle-height-md h-graphic-rectangle-height-md"
              />
              <p className="text-text-primary text-font-sm pt-padding-sm items-center">
                No data found.
              </p>

              {condition ? (
                <>
                  {" "}
                  <div
                    style={{
                      paddingTop: "var(--padding-sm)",
                    }}
                  >
                    <PrimaryButton
                      isDisabled={
                        filterOpen || showAdditionalDetails || showCalendar
                      }
                      enabledBgColor="var(--primary-act)"
                      btnText="Clear parameters"
                      enabledTextColor="var(--text-primary)"
                      handleFunction={() => {
                        move();

                        if (props?.flow === "rejectStatementdetails") {
                          setAccountNumber([props?.ownerDetailId]);
                        } else {
                          setAccountNumber(accountDefaultNumber);
                        }
                        setCreditAmount("");
                        setSelectedtBankState("");

                        setAmountRangeFilter({
                          min: "",
                          max: "",
                        });
                        setUnMatchStatement("");
                        setMatchStatement("");
                        setMatchButton("");
                        setIsAmtFilterApplied(false);
                        if (props?.flow === "rejectStatementdetails") {
                          setStartDateState("");
                          setEndDateState("");
                        } else {
                          setStartDateState(defaultStartDate);
                          setEndDateState(defaultEndDate);
                        }

                        setIsDateConfirm(false);
                        setCurrentPage(1);
                      }}
                      buttonRef={selectAccountRef}
                      hoverOption="white"
                    />
                  </div>
                </>
              ) : (
                <>
                  {" "}
                  <div className=" mt-margin-sm">
                    <PrimaryButton
                      enabledBgColor="var(--primary-act)"
                      btnText="Change date range"
                      enabledTextColor="var(--text-primary)"
                      handleFunction={() => {
                        setopenDateFilter(true);
                      }}
                      buttonRef={selectAccountRef}
                      hoverOption="white"
                    />
                  </div>
                </>
              )}
            </div>
          )}
        </div>
        <div
          className={`${
            getAssociatedItemisedData?.total_count ===
              GlobalConfiguration.lengthCheckZero ||
            props?.flow !== "rejectStatementdetails" ||
            getAssociatedItemisedLoading ||
            ownerAllAccItemisedLoading
              ? "hidden"
              : "block h-pagination-height"
          }`}
        ></div>
      </div>
    </>
  );
};

export default OwnerAccountConsolidatedLiveStatementComp;
